import authenticatedRequest from '../authenticatedRequest';
import invariant from 'invariant';
import labelRequest from '../labelRequest';

export default function consentTermsAndConditions(params) {
    const { baseUrl, brandId, country, uberToken, clientId, language, consentField } = params;

    invariant(baseUrl, 'baseUrl is a required param of consentTermsAndConditions()');
    invariant(brandId, 'brandId is a required param of consentTermsAndConditions()');
    invariant(country, 'country is a required param of consentTermsAndConditions()');
    invariant(clientId, 'clientId is a required param of consentTermsAndConditions()');
    invariant(language, 'language is a required param of consentTermsAndConditions()');
    invariant(consentField, 'consentField is a required param of consentTermsAndConditions()');

    const headers = { 'Content-Type': 'application/json' };
    const url = `${baseUrl}setNewUserConsents/${brandId}_${country}`;

    const jsonBody = JSON.stringify({
        language,
        preferences: { [consentField]: { isConsentGranted: true } },
    });

    return labelRequest(
        authenticatedRequest(
            new Request(url, {
                headers: new Headers(headers),
                method: 'POST',
                body: jsonBody,
            }),
            uberToken,
            clientId,
        ),
        'consentTermsAndConditions',
    );
}
